import React from "react";

import {
  //Table
  CTableRow,
  CTableHead,
  CTableHeaderCell
} from "@coreui/react";

const THead = (props) => {
  return (
    <CTableHead>
      <CTableRow>
        <CTableHeaderCell scope="col">Nome</CTableHeaderCell>
        <CTableHeaderCell scope="col">Data</CTableHeaderCell>
        <CTableHeaderCell scope="col">Leilões Acessados</CTableHeaderCell>
        <CTableHeaderCell scope="col">Leilões Ganhos</CTableHeaderCell>
      </CTableRow>
    </CTableHead>
  );
}

export default THead;